import React from 'react';

function Cube() {
  return(
    <section className="cube">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </section>
  )
}

export default Cube;